// src/hooks/useFetchTableData.js
import { useQuery } from "@tanstack/react-query";
import api from "../api";

const fetchTableData = async ({ queryKey }) => {
  const [, { tableId, page, size, column, direction }] = queryKey;

  const url = `/Data/GetDataByTable/${tableId}/${page}/${size}?SelectedColumn=${column}&SortDirection=${direction}`;
  const response = await api.get(url);
  return response.data;
};

export const useFetchTableData = ({ tableId, page, size, column, direction }) =>
  useQuery({
    queryKey: ["tableData", { tableId, page, size, column, direction }],
    queryFn: fetchTableData,
    keepPreviousData: true,
  });
